import CONFIG from '../../config';

const actions = {
  dualDocumentDocuments(context) {
    context.commit('ADD_LOG', { request: 'dualDocumentDocuments' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(CONFIG.getEndpoint('dualDocumentDocuments'), {
          headers: {
            Authorization: localStorage.getItem('token'),
          }
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'dualDocumentDocuments' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'dualDocumentDocuments' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  dualDocumentAdditionalDocuments(context, params) {
    context.commit('ADD_LOG', { request: 'dualDocumentAdditionalDocuments' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(CONFIG.getEndpoint('dualDocumentAdditionalDocuments', params.applicationId), {
          headers: {
            Authorization: localStorage.getItem('token'),
          }
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'dualDocumentAdditionalDocuments' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'dualDocumentAdditionalDocuments' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  getDualDocumentName(context, params) {
    context.commit('ADD_LOG', { request: 'getDualDocumentName' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(CONFIG.getEndpoint('dualDocumentName', params.applicationId), {
          headers: {
            Authorization: localStorage.getItem('token'),
          }
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'getDualDocumentName' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'getDualDocumentName' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  postDualDocumentName(context, params) {
    context.commit('ADD_LOG', { request: 'postDualDocumentName' });
    return new Promise((resolve, reject) => {
      this.axios
        .post(CONFIG.getEndpoint('dualDocumentName', params.applicationId), params.postParams, {
          headers: {
            Authorization: localStorage.getItem('token'),
          }
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'postDualDocumentName' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'postDualDocumentName' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  getDualDocumentDob(context, params) {
    context.commit('ADD_LOG', { request: 'getDualDocumentDob' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(CONFIG.getEndpoint('dualDocumentDob', params.applicationId), {
          headers: {
            Authorization: localStorage.getItem('token'),
          }
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'getDualDocumentDob' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'getDualDocumentDob' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  postDualDocumentDob(context, params) {
    context.commit('ADD_LOG', { request: 'postDualDocumentDob' });
    return new Promise((resolve, reject) => {
      this.axios
        .post(CONFIG.getEndpoint('dualDocumentDob', params.applicationId), params.postParams, {
          headers: {
            Authorization: localStorage.getItem('token'),
          }
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'postDualDocumentDob' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'postDualDocumentDob' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
};
export default actions;
